import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from "react-redux";
import Loader from "./layout/loading/loader";
import {Formik} from "formik";
import './UsersNewOrEdit.css'
import {number, object, string} from 'yup';
import {Container} from "@mui/material";
import {useParams} from "react-router-dom";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SubmitButton from "./layout/forms/SubmitButton";
import {problemsActions} from "../../modules/problems/problems.actions";
import ProblemDataField from "./problems/form/ProblemDataField";
import {Engineering} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import Constants from "../../utils/constants";
import {prestationsActions} from "../../modules/prestations/prestations.actions.js";
import PrestationDataField from "./prestations/form/PrestationDataField.js";
import Grid from "@mui/material/Grid2";


const prestationValidationSchema = object({
    libelle: string()
        .required("Le libellé est requis")
        .max(255, 'Le libellé ne doit pas dépasser 255 caractères'),
});

function PrestationNewOrEdit({...props}) {
    const dispatch = useDispatch();
    const params = useParams();
    const [mode, setMode] = useState("create");
    const [prestationId, setPrestationId] = useState(null);

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setMode("edit");
            setPrestationId(params.id);
        } else {
            setMode("create");
            setPrestationId(null);
        }
    }, [params]);

    useEffect(() => {
        if (prestationId && (props.problem?.id !== parseInt(prestationId)) && !props.loading && !props.error) {
            dispatch(prestationsActions.fetchPrestation(prestationId));
        }
    }, [dispatch, prestationId]);


    const handleSubmit = (values) => {
        if (mode === "create") {
            dispatch(prestationsActions.createPrestation(values));
        } else {
            dispatch(prestationsActions.updatePrestation(values, values.id));
        }
    }

    const initialValues = {
        id: props.prestation?.id ?? null,
        libelle: props.prestation?.libelle ?? '',
    }

    if (props.loading) {
        return <Loader/>;
    }

    return (
        <>
            <PageTitle title={mode === "create" ? "Nouvelle Prestation" : "Modifier la prestation"} icon={<Engineering/>}/>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={prestationValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <PrestationDataField values={values} errors={errors} handleChange={handleChange}
                                          handleBlur={handleBlur}/>

                        <Grid container justifyContent="center" style={{marginTop: '2rem'}}>
                            <Grid size={4}>
                                <SubmitButton submitting={isSubmitting && !props.error}/>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        prestation: state.prestations.prestation,
        loading: state.prestations.loading,
        error: state.prestations.error
    }
}

export default connect(mapStateToProps)(PrestationNewOrEdit);
